// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_29-1";
export var rateTableServiceLevelDropdown = "_29-3";
export var rateTableTypeDropdown = "_29-0";
export var rateTableValueModeDropdown = "_29-2";